module.exports = __webpack_public_path__ + "static/media/football-carousel-800x1280.0e2bd2d4.jpg";